import UserStatusOptions from "./users-status-settings"
import UserDepartmentsOptions from "./departments-settings"
// import TeamSettings from "./teams-settings"

const UsersSettingsGroup = () => {
  return (
    <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2'>
      <UserStatusOptions />
      {/* <TeamSettings /> */}
      <UserDepartmentsOptions />
    </div>
  )
}

export default UsersSettingsGroup
